import React from "react";
import { Col, Row } from "react-bootstrap";
import useSWR from "swr";
import { Facebook as FacebookLoader } from "react-content-loader";

import fetcher from "libs/swr";
import { useAppContext } from "libs/contextLib";

import CourseListItem from "./CourseListItem";

import { STUDENT_URLS } from "constants/urls";

import "./subscribe-course-list.scss";

export default function SubscribedCourseList() {
  const { authenticatedUser, authenticateUser } = useAppContext();

  const { data, error } = useSWR(
    authenticatedUser ? STUDENT_URLS.SUBSCRIBED_COURSE_LIST : null,
    fetcher
  );

  if (!authenticatedUser) {
    return null;
  } else if (!data && !error) {
    return <FacebookLoader foregroundColor="#F6C6C6" />;
  } else if (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      authenticateUser(null);
      return null;
    } else {
      return (
        <Row className="mx-1">
          <Col xs="auto" className="rounded no-results text-dark">
            An error occurred in fetching courses. Please try again.
          </Col>
        </Row>
      );
    }
  } else if (!Array.isArray(data.results) || !data.results.length) {
    return (
      <Row className="mx-1">
        <Col xs="auto" className="rounded no-results text-dark">
          Explore courses below to find a good fit. Try out classes before
          subscribing to a course!
        </Col>
      </Row>
    );
  } else {
    return data.results.map((item) => (
      <CourseListItem course={item} key={item.id} />
    ));
  }
}
